import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

function FirstCopyCoachmark({ onDismiss }) {
  return (
    <aside className="first-copy-coachmark" aria-labelledby="first-copy-coachmark-title">
      <div className="first-copy-coachmark__arrow" aria-hidden="true" />
      <div id="first-copy-coachmark-title" className="first-copy-coachmark__title">
        Seleccioná una publicación para empezar
      </div>
      <div className="first-copy-coachmark__description">
        Elegí una publicación del listado. Después podrás publicarla en otra cuenta.
      </div>
      <Button type="button" basic size="mini" className="first-copy-coachmark__dismiss" onClick={onDismiss}>
        Entendido <Icon name="check" />
      </Button>
    </aside>
  );
}

export default FirstCopyCoachmark;
